import { CargoItem, RequireOnly } from '@pelicargo/types';
import { Cargo, HandlingOptions } from '@prisma/client';
import { uniq } from 'lodash';

import { getPrettyHandling, getPrettyPackingGroup } from '.';

const HANDLING_OPTIONS = [HandlingOptions.Stackable, HandlingOptions.NonStackable];

const PACKING_OPTIONS = [HandlingOptions.Drums, HandlingOptions.Pails, HandlingOptions.Supersacks];

export const getHandlingAndPacking = (cargo: RequireOnly<Cargo, 'handling'> | RequireOnly<CargoItem, 'handling'>) => {
  const handlingAndPacking = [];

  const handling = Array.isArray(cargo?.handling) ? cargo?.handling : [cargo.handling];

  handling?.map((option) => {
    handlingAndPacking.push([...HANDLING_OPTIONS, ...PACKING_OPTIONS]?.find((item) => item === option));
  });
  const unique = uniq(handlingAndPacking);
  return unique?.map((node) => getPrettyHandling(node) || getPrettyPackingGroup(node)).join(', ');
};
